import { Component, EventEmitter, Input, NgZone, OnChanges, Output, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';
import { GridComponent, GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { process, State, orderBy } from '@progress/kendo-data-query';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmDialog } from '../modals/confirm-dialog.component';
import { EmployeeService } from '../../services/employees.service';
import { UtilService } from '../../services/util.service';
import {
    Employee,
    SearchEmployeeGroup
} from '../../models/models';

@Component({
    selector: 'employee-group-assign',
    templateUrl: './employee-group-assign.component.html',
    standalone: false
})
export class EmployeeGroupAssign implements OnChanges {
    @Input() tableID: number = 0;
    @Input() tableHeader: string = "Employee Group";
    @Output() onRefresh = new EventEmitter<any>();

    @ViewChild(GridComponent, { static: false }) public tableGrid!: GridComponent;

    public isAdd: boolean = false;

    public tableList: SearchEmployeeGroup[] = [];
    public employeeList: Employee[] = [];
    public employeeID: number = 0;

    public gridData: GridDataResult = { data: [], total: 0 };
    public gridState: State = { skip: 0, take: 10, sort: [{ dir: 'asc', field: "lastName" }, { dir: 'asc', field: 'firstName' }] };

    constructor(private employeeService: EmployeeService, private utilService: UtilService, private dialog: MatDialog, private ngZone: NgZone) {
    }

    ngOnChanges() {
        this.getTableList();
    }

    private getEmployees() {
        this.employeeService.getActiveEmployees().subscribe(result => {
            this.employeeList = [];
            var lst: Employee[] = result;
            for (var i = 0; i < lst.length; i++) {
                var idx = this.tableList.findIndex(t => t.employeeID == lst[i].employeeId);
                if (idx < 0) {
                    this.employeeList.push(lst[i]);
                }
            }
        });
    }

    private getTableList() {
        this.utilService.isLoading = true;
        this.employeeService.getSearchEmployeeGroupByGroupID(this.tableID).subscribe(result => {
            this.utilService.isLoading = false;
            this.tableList = result.resultCollection;
            this.setGrid();
        });
    }

    private setGrid() {
        if (this.gridState.sort) this.tableList = orderBy(this.tableList, this.gridState.sort);

        this.gridData = process(this.tableList, this.gridState);
        this.fitColumns();
    }

    private fitColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.tableGrid == null) return;
            this.tableGrid.autoFitColumns();
        });
    }

    public dataStateChange(state: DataStateChangeEvent) {
        this.gridState = state;
        this.setGrid();
    }

    public save() {
        this.employeeService.saveEmployeeGroupMap(this.tableID, this.employeeID).subscribe(result => {
            this.isAdd = false;
            this.getTableList();
        });
    }

    public delete(employeeGroupMapID: number) {
        var idx = this.tableList.findIndex(c => c.employeeGroupMapID == employeeGroupMapID);

        if (idx == null || idx < 0) return;

        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            header: 'Delete?',
            message: 'Would you like to remove this employee?'
        }

        const dialogRef = this.dialog.open(ConfirmDialog, dialogConfig);

        dialogRef.afterClosed().subscribe(dialogResult => {
            if (!dialogResult) return;

            this.employeeService.deleteEmployeeGroupMap(employeeGroupMapID).subscribe(result => {
                this.getTableList();
            });
        });
    }

    public addNew() {
        this.getEmployees();
        this.isAdd = true;
    }

    public cancel() {
        this.isAdd = false;
        this.getTableList();
    }

    public close() {
        this.isAdd = false;
        this.onRefresh.emit();
    }
}
